import { render, staticRenderFns } from "./papwaClass.vue?vue&type=template&id=10f2d32a&scoped=true"
import script from "./papwaClass.vue?vue&type=script&lang=js"
export * from "./papwaClass.vue?vue&type=script&lang=js"
import style0 from "./papwaClass.vue?vue&type=style&index=0&id=10f2d32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2d32a",
  null
  
)

export default component.exports